
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/press/[project]",
      function () {
        return require("private-next-pages/[locale]/press/[project].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/press/[project]"])
      });
    }
  